import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";
import { User, UserID } from "./User";

export type DealerDocumentationID = number;

export enum DEALER_DOCUMENTATION_CATEGORIES {
  Warranty = 1,
  Technical = 2,
  Cosmetic = 3,
  Commercial = 4,
  Internal = 5,
  External = 6,
  Manual = 7
}

export interface DealerDocumentation {
  created_on: string;
  updated_on: string;
  id: DealerDocumentationID;
  title: string; // Title
  content: string; // Content
  url: string | null; // URL containing related PDF document
  publish_date: string | null; // Date when this documentation becomes published
  is_pinned: boolean; // The documentation is important and needs to be displayed first
  visible_to_mechanic: boolean; // Documentation is visible to Mechanic Users
  visible_to_all: boolean; // Documentation is visible to all locations of a dealer
  category_id: DEALER_DOCUMENTATION_CATEGORIES; // Type of documentation
  created_by_id: UserID; // User Identifier who created this documentation
  updated_by_id: UserID | null; // User Identifier who last updated this documenttion
  dealer_location_ids?: DealerLocationID[]; // Location Identifiers that can view this documentation
  dealer_ids?: DealerID[]; // Dealers that can view this documentation
  created_by?: User; // Embedded User who created this documentation
  updated_by?: User; // Embedded User who last updated this documentation
}

export interface DealerDocumentationDealer {
  dealer_id: DealerID; // Dealer Identifier
  dealer_documentation_id: DealerDocumentationID; // Documentation Identifier
}

export interface DealerDocumentationLocation {
  dealer_location_id: DealerLocationID; // Location Identifier
  dealer_documentation_id: DealerDocumentationID; // Documentation Identifier
}
